import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { useCallback } from "react";
import { SourceConfigCode } from "./SourceConfigCode.js";
import { SourceList } from "./SourceList.js";
import { getSelectedSource, getSelectedSourceId, getSelectedSourceLayerId, getSelectedSourceLayerLayer, getSelectedSourceLayerLayerId, getSourcesConfigDisplay } from "../../reducers/sourcesReducer.js";
import { useAppSelector } from "../../hooks/redux.js";
import { SourceConfigData } from "./SourceConfigData.js";
import { SourceLayerConfigData } from "./SourceLayerConfigData.js";
import { getSelectedSourceInfo } from "../../utils/selectors.js";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
export const SourcesView = ({ onViewChange }) => {
    const captureEvent = useCaptureEvent();
    const selectedId = useAppSelector(getSelectedSourceId);
    const selected = useAppSelector(getSelectedSource);
    const selectedSourceLayer = useAppSelector(getSelectedSourceLayerId);
    const layer = useAppSelector(getSelectedSourceLayerLayer);
    const selectedSourceLayerLayerId = useAppSelector(getSelectedSourceLayerLayerId);
    const configDisplay = useAppSelector(getSourcesConfigDisplay);
    const sourceInfo = useAppSelector(getSelectedSourceInfo);
    const onClose = useCallback(() => {
        captureEvent(Event.CloseSourcesPanel);
        onViewChange("ai");
    }, [captureEvent, onViewChange]);
    return (_jsxs(Flex, { h: "100%", w: selectedId ? "640px" : "320px", children: [_jsx(SourceList, { selectedSourceId: selectedId, selectedSourceLayerId: selectedSourceLayer, selectedSourceLayerLayerId: selectedSourceLayerLayerId, onClose: onClose }), !selectedSourceLayer && selected && selectedId && configDisplay === "code" && (_jsx(SourceConfigCode, { sourceId: selectedId, source: selected })), !selectedSourceLayer && selected && selectedId && configDisplay === "data" && (_jsx(SourceConfigData, { sourceId: selectedId, source: selected, sourceInfo: sourceInfo })), selectedSourceLayer && selected && selectedId && (_jsx(SourceLayerConfigData, { layer: layer, sourceLayerId: selectedSourceLayer, sourceInfo: sourceInfo }))] }));
};
